import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import RoundIndicatorIcon from "../../../assets/icons/RoundIndicatorIcon";

export default function NotificationsPanelUnreadIndicator({ handleMarkAsRead }) {
  return (
    <Box onClick={handleMarkAsRead} sx={{ "&:hover": { cursor: "pointer" }}}>
      <RoundIndicatorIcon sx={{ color: "primary.60" }}/>
    </Box>
  );
}

NotificationsPanelUnreadIndicator.propTypes = {
  handleMarkAsRead: PropTypes.func.isRequired
};